// This file is part of re-motion
// Copyright (c) rubicon IT GmbH, www.rubicon.eu
// 
import { IRpcContext } from "@lib/messaging/rpc/IRpcContext";
import { RpcCallback } from "@lib/messaging/rpc/RpcCallback";
import { RpcResult } from "./RpcResult";

/**
 * Provides an API for registering and calling local RPC methods.
 */
export interface ILocalRpcHub<TRpcContext extends IRpcContext>
{
  has(method: string): boolean;
  invoke<T, E>(context: TRpcContext, method: string, args: any[], timeout: Optional<number>): RpcResult<T, E>;
  notify(context: TRpcContext, method: string, args: any[]): void;
  off(method: string): void;
  on(method: string, callback: RpcCallback<TRpcContext>): void;
}